<div class="content">
  <div class="info-banner">
    <glxy-alert type="info">
      <div [innerHTML]="'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.HELP_ARTICLE_LINK' | translate"></div>
    </glxy-alert>
  </div>
  <div class="description title">
    {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.METHOD' | translate }}
  </div>
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.POST' | translate }}
  </div>
  <ng-container *ngIf="loadingForm === false; else loading">
    <form [formGroup]="form">
      <glxy-form-field required="true" prefixText="https://">
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.WEBHOOK_URL' | translate }}
        </glxy-label>
        <input
          matInput
          type="text"
          formControlName="endpoint_url"
          [required]="(automationViewService.isNonPartnerAutomation() | async) !== true"
        />
        <glxy-error *ngIf="form.controls.endpoint_url?.hasError('required') && form.controls.endpoint_url.dirty">
          {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.REQUIRED_FIELD' | translate }}
        </glxy-error>
        <glxy-error *ngIf="form.controls.endpoint_url?.hasError('url') && form.controls.endpoint_url.dirty">
          {{ 'AUTOMATIONS.VALIDATORS.INVALID_URL' | translate }}
        </glxy-error>
        <glxy-error *ngIf="form.controls.endpoint_url?.hasError('secure') && form.controls.endpoint_url.dirty">
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.WEBHOOK_URL_SECURE' | translate }}
        </glxy-error>
      </glxy-form-field>

      <glxy-form-field>
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.VERIFIER_TOKEN' | translate }}
        </glxy-label>
        <glxy-label-hint>
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.VERIFIER_TOKEN_DESC' | translate }}
        </glxy-label-hint>
        <input matInput type="text" formControlName="verifier_token" />
      </glxy-form-field>

      <div class="description title">
        {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.SAMPLE_HEADER' | translate }}
      </div>
      <div class="description subtitle">
        <p>
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.SAMPLE_HEADER_DESC' | translate }}
        </p>
        content-type:application/json
        <br />
        from:autobots&#64;vendasta.com
        <br />
        verifier-token:{{ '{{' }} verifier_token {{ '}}' }}
        <br />
      </div>

      <div class="description title">
        {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.SAMPLE_BODY' | translate }}
      </div>
      <div class="description subtitle">
        <p>
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.SAMPLE_BODY_DESC' | translate }}
        </p>
        {{ '{' }}
        <br />
        <div class="move-right">
          "partnerId": "{{ namespace$ | async }}",
          <br />
          "accountId": "{{ '{{ accountId }}' }}",
          <br />
          <ng-container *ngIf="getEntityIDReplacementString() as entityIDReplacementString">
            "entityId": "{{ entityIDReplacementString }}",
            <br />
          </ng-container>
          "automationId": "{{ (currentAutomationService.automation$ | async)?.id }}",
          <br />

          <div *ngFor="let additionalField of form.controls.additional_fields.value">
            <ng-container>
              "{{
                additionalField.id || 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.EMPTY_FIELD_VALUE' | translate
              }}": "{{
                additionalField.value || 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.EMPTY_FIELD_VALUE' | translate
              }}",
              <br />
            </ng-container>
          </div>
        </div>
        {{ '}' }}
        <br />
      </div>
      <div>
        <ng-container>
          <div class="description">
            {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.ADDITIONAL_FIELDS' | translate }}
          </div>
          <div class="description secondary subtitle">
            {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.ADD_ADDITIONAL_FIELDS' | translate }}
          </div>
          <div
            formArrayName="additional_fields"
            *ngFor="let additionalField of additionalFieldsGetter; let i = index"
            class="return-key-values-container"
          >
            <ng-container [formGroupName]="i">
              <glxy-form-field class="key-name-field">
                <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.FIELD' | translate }}</glxy-label>
                <input matInput formControlName="id" />
              </glxy-form-field>
              <glxy-form-field>
                <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.VALUE' | translate }}</glxy-label>
                <input matInput id="value-{{ i }}" formControlName="value" />
                <automata-automation-variable-menu
                  [supportedDataTypes]="allDataTypes"
                  (variableSelected)="
                    insertVariable(
                      'value-' + i,
                      $any(form.controls.additional_fields).controls[i].controls.value,
                      $event
                    )
                  "
                  matSuffix
                  useGalaxyCompat="true"
                  class="dynamic-content-icon"
                ></automata-automation-variable-menu>
              </glxy-form-field>
              <button mat-icon-button color="secondary" (click)="removeField(i)">
                <mat-icon>close</mat-icon>
              </button>
            </ng-container>
          </div>
          <br />
          <button mat-button color="primary" (click)="addField()" class="additional-fields">
            {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.ADD_FIELD' | translate }}
          </button>
        </ng-container>
      </div>

      <div>
        <button mat-flat-button color="primary" [disabled]="!form.valid && !submitting" (click)="sendTestWebhook()">
          {{ 'AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.PANEL.SEND_TEST_WEBHOOK' | translate }}
        </button>
      </div>
    </form>
  </ng-container>
</div>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
